import { c as _c } from "react/compiler-runtime";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { Alert, Dialog, Text } from "@flat-ui";
/**
 *  A dialog prompting the user to confirm or cancel the deletion of a markup.
 *  The dialog will also show a warning message that the operation cannot be undone.
 */
export function DeleteMarkupDialog(t0) {
  const $ = _c(12);
  const {
    dialogContent,
    onClose,
    onConfirm,
    isDeleting,
    shouldShowWarning: t1
  } = t0;
  const shouldShowWarning = t1 === undefined ? true : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignSelf: "stretch",
      mb: SPACE_ELEMENTS_OF_MODAL
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== dialogContent.description) {
    t3 = <Text variant="bodyM" sx={t2}>{dialogContent.description}</Text>;
    $[1] = dialogContent.description;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== shouldShowWarning) {
    t4 = shouldShowWarning && <Alert variant="warning" title="The operation cannot be undone." />;
    $[3] = shouldShowWarning;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== dialogContent.title || $[6] !== isDeleting || $[7] !== onClose || $[8] !== onConfirm || $[9] !== t3 || $[10] !== t4) {
    t5 = <Dialog title={dialogContent.title} confirmText="Delete" open={true} showSpinner={isDeleting} onConfirm={onConfirm} onCancel={onClose} variant="danger">{t3}{t4}</Dialog>;
    $[5] = dialogContent.title;
    $[6] = isDeleting;
    $[7] = onClose;
    $[8] = onConfirm;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}